(function () {
    "use strict";

    function viewDocumentController($interval, documentsService, propertyesDocuViewer, $sce, currentUser, fileitemService, $location,
        officePublicService, TYPEVIEWERS, $window, officeServerService, URL) {

        var vm = this;
        vm.url = '';
        vm.propertyes = new propertyesDocuViewer();
        vm.cargando = true;
        vm.throwLoaded = false;
        vm.showMessageNoOffice = false;

        vm.iframeLoadedCallBack = function () {
            vm.cargando = false;
            $interval(function () {
                vm.cargando = false;
            }, 1000);
        };

        function loadedFile() {
            if (vm.onLoaded && !vm.throwLoaded) {
                vm.throwLoaded = true;
                vm.onLoaded();
            }
        }

        function addEventListener() {
            if ($window.addEventListener) {
                $window.addEventListener('message', loadedFile);
            }
            else {
                $window.attachEvent('onmessage', loadedFile);
            }
        }

        function removeEventListener() {
            if ($window.removeEventListener) {
                $window.removeEventListener('message', loadedFile);
            }
            else {
                $window.detachEvent('onmessage', loadedFile);
            }
        }

        function cargarViewer() {
            if (vm.isFilecontainer && !vm.isPublicDocument) {
                loadFileItemViewer();
            } else if (vm.isFilecontainer && vm.isPublicDocument) {
                loadFileItemPublicViewer();
            } else if (!vm.isPublicDocument) {
                loadItemBoxViewer();
            } else {
                loadItemBoxPublicViewer();
            }
        }

        function geturltenant() {
            return URL.URL;
        }

        function getUrlViewerEncode(data) {
            documentsService.gerUrlViewerEncode(data)
                .then(function (dataEncode) {
                    vm.url = $sce.trustAsResourceUrl(dataEncode);
                })
                .catch(function () {
                    vm.cargando = false;
                });
        }

        function getUrlViewerEncodePublic(data) {
            documentsService.gerUrlViewerEncodePublic(data)
                .then(function (dataEncode) {
                    vm.url = $sce.trustAsResourceUrl(dataEncode);
                })
                .catch(function () {
                    vm.cargando = false;
                });
        }

        function loadFileItemViewer() {
            var sePuedeAbrirConOffice = false;
            vm.showMessageNoOffice = false;
            var urltenant = geturltenant();

            if (vm.typeViewer === TYPEVIEWERS.office) {

                officeServerService.isOfficerServer.private()
                    .then(function (openWithOfficeServerSolpheo) {
                        if (openWithOfficeServerSolpheo) {
                            officeServerService.documentary.private(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view")
                                .then(function (data) {
                                    var hostViewerOffice = data;
                                    if (hostViewerOffice.canOpen) {
                                        vm.url = $sce.trustAsResourceUrl(hostViewerOffice.url);
                                    } else {
                                        vm.cargando = false;
                                        console.log('Not can open with office');
                                        vm.showMessageNoOffice = true;
                                    }
                                })
                                .catch(function () {
                                    vm.cargando = false;

                                });
                        } else {
                            fileitemService.sePuedeAbrirConOffice(vm.idContenedor, vm.idDocument, "view")
                                .then(function (data) {
                                    sePuedeAbrirConOffice = data;
                                    if (sePuedeAbrirConOffice) {
                                        var urlViewerOffice = '';
                                        fileitemService.abrirConOffice(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view", vm.propertyes.enableprint)
                                            .then(function (data) {
                                                urlViewerOffice = data;
                                                vm.url = $sce.trustAsResourceUrl(urlViewerOffice);
                                            })
                                            .catch(function () {
                                                vm.cargando = false;

                                            });
                                    } else {
                                        vm.cargando = false;
                                        console.log('Not can open with office');
                                        vm.showMessageNoOffice = true;
                                    }
                                })
                                .catch(function () {
                                    vm.cargando = false;

                                });
                        }
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });


            } else if (vm.typeViewer === TYPEVIEWERS.gd) {
                fileitemService.getUrlAppViewer()
                    .then(function (data) {

                        var dataUrl = {
                            urlAppViewer: data.urlAppViewer,
                            urlData: {
                                idBox: vm.idContenedor,
                                idDocument: vm.idDocument,
                                token: currentUser.profile.token,
                                urltenant: urltenant,
                                isFileContainer: vm.isFilecontainer,
                                canPrint: vm.propertyes.enableprint,
                                language: vm.propertyes.language,
                                pageRotation: vm.getPageRotations ? true : false
                            }
                        };

                        getUrlViewerEncode(dataUrl);
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });
            } else {
                vm.cargando = false;
            }
        }

        function loadFileItemPublicViewer() {
            var canBeOpenedWithOffice = false;
            vm.showMessageNoOffice = false;
            var urltenant = geturltenant();

            if (vm.typeViewer === TYPEVIEWERS.office) {

                officeServerService.isOfficerServer.public()
                    .then(function (openWithOfficeServerSolpheo) {
                        if (openWithOfficeServerSolpheo) {
                            officeServerService.documentary.public(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password)
                                .then(function (data) {
                                    var hostViewerOffice = data;
                                    if (hostViewerOffice.canOpen) {
                                        vm.url = $sce.trustAsResourceUrl(hostViewerOffice.url);
                                    } else {
                                        vm.cargando = false;
                                        console.log('Not can open with office');
                                        vm.showMessageNoOffice = true;
                                    }
                                })
                                .catch(function () {
                                    vm.cargando = false;

                                });
                        } else {
                            officePublicService.canBeOpenedWithOfficeDocumentary(vm.idContenedor, vm.idDocument, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password)
                                .then(function (data) {
                                    canBeOpenedWithOffice = data;
                                    if (canBeOpenedWithOffice) {
                                        var urlViewerOffice = '';
                                        officePublicService.openWithOfficeDocumentary(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password, vm.propertyes.enableprint)
                                            .then(function (data) {
                                                urlViewerOffice = data;
                                                vm.url = $sce.trustAsResourceUrl(urlViewerOffice);
                                            })
                                            .catch(function () {
                                                vm.cargando = false;

                                            });
                                    } else {

                                        vm.cargando = false;
                                    }
                                })
                                .catch(function () {
                                    vm.cargando = false;

                                });
                        }
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });




            } else if (vm.typeViewer === TYPEVIEWERS.gd) {
                officePublicService.getUrlAppViewer(vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password)
                    .then(function (data) {
                        var dataUrl = {
                            urlAppViewer: data.urlAppViewer,
                            urlData: {
                                idBox: vm.idContenedor,
                                idDocument: vm.idDocument,
                                token: currentUser.profile.token,
                                urltenant: urltenant,
                                isFileContainer: true,
                                canPrint: vm.propertyes.enableprint,
                                language: vm.propertyes.language,
                                pageRotation: vm.getPageRotations ? true : false,
                                idUrl: vm.publicDocumentCredentials.idUrl,
                                hash: vm.publicDocumentCredentials.hash,
                                password: vm.publicDocumentCredentials.password
                            }
                        };

                        getUrlViewerEncodePublic(dataUrl);
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });
            } else {
                vm.cargando = false;
            }
        }

        function loadItemBoxViewer() {
            var sePuedeAbrirConOffice = false;
            vm.showMessageNoOffice = false;
            var urltenant = geturltenant();

            if (vm.typeViewer === TYPEVIEWERS.office) {

                officeServerService.isOfficerServer.private()
                    .then(function (openWithOfficeServerSolpheo) {
                        if (openWithOfficeServerSolpheo) {

                            var promiseServer;
                            if (vm.isDrive) {
                                promiseServer = officeServerService.drive.private(vm.idDriveProvider, vm.idDrive, vm.idDocument, currentUser.profile.token, "view");
                            } else {
                                promiseServer = officeServerService.workplace.private(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view");
                            }

                            promiseServer.then(function (data) {
                                var hostViewerOffice = data;
                                if (hostViewerOffice.canOpen) {
                                    vm.url = $sce.trustAsResourceUrl(hostViewerOffice.url);
                                } else {
                                    vm.cargando = false;
                                    console.log('Not can open with office');
                                    vm.showMessageNoOffice = true;
                                }
                            }).catch(function () {
                                vm.cargando = false;

                            });
                        }
                        else {
                            var promise;
                            if (vm.isDrive) {
                                promise = documentsService.sePuedeAbrirConOffice_Drive(vm.idDriveProvider, vm.idDrive, vm.idDocument, "view");
                            } else {
                                promise = documentsService.sePuedeAbrirConOffice(vm.idContenedor, vm.idDocument, "view");
                            }
                            promise.then(function (data) {
                                sePuedeAbrirConOffice = data;
                                if (sePuedeAbrirConOffice) {
                                    var urlViewerOffice = '';

                                    if (vm.isDrive) {
                                        promise = documentsService.abrirConOffice_Drive(vm.idDriveProvider, vm.idDrive, vm.idDocument, currentUser.profile.token, "view", vm.propertyes.enableprint);
                                    } else {
                                        promise = documentsService.abrirConOffice(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view", vm.propertyes.enableprint);
                                    }

                                    promise.then(function (data) {
                                        urlViewerOffice = data;
                                        vm.url = $sce.trustAsResourceUrl(urlViewerOffice);
                                    }).catch(function () {
                                        vm.cargando = false;

                                    });
                                } else {
                                    vm.cargando = false;
                                    console.log('Not can open with office');
                                    vm.showMessageNoOffice = true;
                                }
                            })
                                .catch(function () {
                                    vm.cargando = false;

                                });
                        }
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });




            } else if (vm.typeViewer === TYPEVIEWERS.gd) {

                documentsService.getUrlAppViewer()
                    .then(function (data) {
                        var url;
                        var urlData;

                        if (vm.isDrive) {
                            url = data.urlDriveAppViewer;
                            urlData = {
                                idProvider: vm.idDriveProvider,
                                idDrive: vm.idDrive,
                                idFile: vm.idDocument,
                                token: currentUser.profile.token,
                                urltenant: urltenant,
                                canPrint: vm.propertyes.enableprint,
                                language: vm.propertyes.language
                            };

                        } else {
                            url = data.urlAppViewer;
                            urlData = {
                                idBox: vm.idContenedor,
                                idDocument: vm.idDocument,
                                token: currentUser.profile.token,
                                urltenant: urltenant,
                                isFileContainer: vm.isFilecontainer,
                                canPrint: vm.propertyes.enableprint,
                                language: vm.propertyes.language
                            };
                        }

                        var dataUrl = {
                            urlAppViewer: url,
                            urlData: urlData
                        };

                        getUrlViewerEncode(dataUrl);
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });
            } else {
                vm.cargando = false;
            }
        }

        function loadItemBoxPublicViewer() {
            var canBeOpenedWithOffice = false;
            vm.showMessageNoOffice = false;
            var urltenant = geturltenant();


            if (vm.typeViewer === TYPEVIEWERS.office) {

                officeServerService.isOfficerServer.public()
                    .then(function (openWithOfficeServerSolpheo) {
                        if (openWithOfficeServerSolpheo) {
                            var promiseServer;
                            if (vm.isDrive) {
                                promiseServer = officeServerService.drive.public(vm.idDriveProvider, vm.idDrive, vm.idDocument, currentUser.profile.token, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password);
                            } else {
                                promiseServer = officeServerService.workplace.public(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password);
                            }

                            promiseServer.then(function (data) {
                                var hostViewerOffice = data;
                                if (hostViewerOffice.canOpen) {
                                    vm.url = $sce.trustAsResourceUrl(hostViewerOffice.url);
                                } else {
                                    vm.cargando = false;
                                    console.log('Not can open with office');
                                    vm.showMessageNoOffice = true;
                                }
                            }).catch(function () {
                                vm.cargando = false;

                            });
                        }
                        else {
                            officePublicService.canBeOpenedWithOffice(vm.idContenedor, vm.idDocument, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password)
                                .then(function (data) {
                                    canBeOpenedWithOffice = data;
                                    if (canBeOpenedWithOffice) {
                                        var urlViewerOffice = '';
                                        officePublicService.openWithOffice(vm.idContenedor, vm.idDocument, currentUser.profile.token, "view", vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password, vm.propertyes.enableprint)
                                            .then(function (data) {
                                                urlViewerOffice = data;
                                                vm.url = $sce.trustAsResourceUrl(urlViewerOffice);
                                            })
                                            .catch(function () {
                                                vm.cargando = false;

                                            });
                                    } else {

                                        vm.cargando = false;
                                    }
                                })
                                .catch(function () {
                                    vm.cargando = false;

                                });
                        }
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });

            } else if (vm.typeViewer === TYPEVIEWERS.gd) {
                officePublicService.getUrlAppViewer(vm.publicDocumentCredentials.idUrl, vm.publicDocumentCredentials.hash, vm.publicDocumentCredentials.password)
                    .then(function (data) {
                        var dataUrl = {
                            urlAppViewer: data.urlAppViewer,
                            urlData: {
                                idBox: vm.idContenedor,
                                idDocument: vm.idDocument,
                                token: currentUser.profile.token,
                                urltenant: urltenant,
                                canPrint: vm.propertyes.enableprint,
                                language: vm.propertyes.language,
                                idUrl: vm.publicDocumentCredentials.idUrl,
                                hash: vm.publicDocumentCredentials.hash,
                                password: vm.publicDocumentCredentials.password,
                                idFolder: vm.idFolder
                            }
                        };

                        getUrlViewerEncodePublic(dataUrl);
                    })
                    .catch(function () {
                        vm.cargando = false;

                    });
            } else {
                vm.cargando = false;
            }
        }

        function cargarPropertyes() {
            vm.propertyes.id = vm.id === undefined ? vm.propertyes.id : vm.id;
            vm.propertyes.width = vm.width === undefined ? vm.propertyes.width : vm.width;
            vm.propertyes.height = vm.height === undefined ? vm.propertyes.height : vm.height;
            vm.propertyes.showqueuepsadosnapin = vm.showqueuepsadosnapin === undefined ? vm.propertyes.showqueuepsadosnapin : vm.showqueuepsadosnapin;
            vm.propertyes.showpanelheadersnapin = vm.showpanelheadersnapin === undefined ? vm.propertyes.showpanelheadersnapin : vm.showpanelheadersnapin;
            vm.propertyes.showbotonessnapin = vm.showbotonessnapin === undefined ? vm.propertyes.showbotonessnapin : vm.showbotonessnapin;
            vm.propertyes.showbotonqueuepsar = vm.showbotonqueuepsar === undefined ? vm.propertyes.showbotonqueuepsar : vm.showbotonqueuepsar;
            vm.propertyes.showanotaciones = vm.showanotaciones === undefined ? vm.propertyes.showanotaciones : vm.showanotaciones;
            vm.propertyes.showsearch = vm.showsearch === undefined ? vm.propertyes.showsearch : vm.showsearch;
            vm.propertyes.showthumbnails = vm.showthumbnails === undefined ? vm.propertyes.showthumbnails : vm.showthumbnails;
            vm.propertyes.enableabrir = vm.enableabrir === undefined ? vm.propertyes.enableabrir : vm.enableabrir;
            vm.propertyes.enableabriruri = vm.enableabriruri === undefined ? vm.propertyes.enableabriruri : vm.enableabriruri;
            vm.propertyes.enabletwain = vm.enabletwain === undefined ? vm.propertyes.enabletwain : vm.enabletwain;
            vm.propertyes.enableguardar = vm.enableguardar === undefined ? vm.propertyes.enableguardar : vm.enableguardar;
            vm.propertyes.enableprint = vm.enableprint === undefined ? vm.propertyes.enableprint : vm.enableprint;
            vm.propertyes.showtoolbar = vm.showtoolbar === undefined ? vm.propertyes.showtoolbar : vm.showtoolbar;
            vm.propertyes.canrellenarcampospdf = vm.canrellenarcampospdf === undefined ? vm.propertyes.canrellenarcampospdf : vm.canrellenarcampospdf;
            vm.propertyes.showbookmark = vm.showbookmark === undefined ? vm.propertyes.showbookmark : vm.showbookmark;
            vm.propertyes.language = vm.language === undefined ? vm.propertyes.language : vm.language;
        }

        vm.$onInit = function () {
            removeEventListener();
            addEventListener();
            cargarViewer();
            cargarPropertyes();
        };
    }

    viewDocumentController.$inject = ['$interval', 'solpheo.documentsService', 'solpheo.propertyesDocuViewer', '$sce', 'sphForms.currentUser', 'solpheo.fileitemService', '$location',
        "solpheo.officePublicService", "TYPEVIEWERS", "$window", "solpheo.officeServerService", "URL"];

    angular.module('solpheo')
        .component('solpheoDocuviewer', {
            templateUrl: 'modules/main/components/viewer/components/docuviewer/documents.docuviewer.template.html',
            controller: viewDocumentController,
            bindings: {
                idContenedor: '<',
                idDocument: '<',
                id: '<',
                width: '<',
                height: '<',
                showqueuepsadosnapin: '<',
                showpanelheadersnapin: '<',
                showbotonessnapin: '<',
                showbotonqueuepsar: '<',
                showanotaciones: '<',
                showsearch: '<',
                showthumbnails: '<',
                enableabrir: '<',
                enableabriruri: '<',
                enabletwain: '<',
                enableguardar: '<',
                enableprint: '<',
                showtoolbar: '<',
                canrellenarcampospdf: '<',
                showbookmark: '<',
                language: '<',
                isFilecontainer: '<',
                idFolder: '<',
                isPublicDocument: '<',
                publicDocumentCredentials: '<',
                typeViewer: '<',
                getPageRotations: '<',

                isDrive: '<',
                idDriveProvider: '<',
                idDrive: '<',
                onLoaded: '&'
            }
        });

    angular.module('solpheo').directive('iframeOnload', [function () {
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function (scope, element) {
                element.on('load', function () {
                    return scope.callBack();
                });
            }
        };
    }]);

}());